import { CartInputsHookValue } from '@/contexts/new-order-actions-context-types';
import { InputValueMap } from '@/utils/new-order';
import { useCallback, useState } from 'react';

const EMPTY_INPUT_VALUE_MAP: InputValueMap = {};

/*
 * Keeps the inputs in memory for the length of the flow instead of saving them
 * to the order row.
 *
 * For inbounds the PO number comes from the one parsed onto the smart order and
 * populated when navigating to the summary screen, so an order row is usually
 * not there yet, and the row must not become a second source of truth.
 */
export const useInboundCartInputs = (): CartInputsHookValue => {
  const [additionalInputValueMap, setAdditionalInputValueMap] =
    useState<InputValueMap>(EMPTY_INPUT_VALUE_MAP);

  const setAdditionalInputValue = useCallback(
    (inputID: string, inputTitle: string, inputValue: string) => {
      setAdditionalInputValueMap((previous) => ({
        ...previous,
        [inputID]: { title: inputTitle, value: inputValue },
      }));
    },
    [],
  );

  const clearActiveCartInputs = useCallback(
    () => setAdditionalInputValueMap(EMPTY_INPUT_VALUE_MAP),
    [],
  );

  const flushPendingInputs = useCallback(() => {}, []);
  const cancelPendingInputs = useCallback(() => {}, []);

  return {
    additionalInputValueMap,
    cancelPendingInputs,
    clearActiveCartInputs,
    flushPendingInputs,
    setAdditionalInputValue,
  };
};
